import jQuery from 'jquery';
import React from "react";
import accordionList from './app/accordion-list';
import resizeGroup from './app/resizer';
import reveal from './app/reveal';
import deQueue from './app/deQueue';
import searchAutocomplete from './app/search-autocomplete';
import showLoader from './app/loader';
import showModal from './app/modal';
import favoriteButton from './app/favorite-button';
import debounce from './app/debounce';
import rangeSlider from './app/range-slider';
import tabs from './app/tabs';
import videoPlayer from './app/videoPlayer'; // TODO 50kb
import toggleGroup from './app/toggleGroup';
import productListLayout from './app/productListLayoutSwitcher';
import gallery from './app/gallery'; // 12kb
import Pikaday from 'pikaday'; // 67kb
import Cookies from 'js-cookie';
import {ProductReviewsWidget} from "./app/product-reviews-widget/product-reviews-widget"; // TODO 38kb (date-fns)
import mobileMenu from './app/mobile-menu';
import Fuse from 'fuse.js';
import SimpleLightbox from 'simple-lightbox';

window.$ = window.jQuery = jQuery;
window.showLoader = showLoader;
window.showModal = showModal;
window.debounce = debounce;

jQuery('html').removeClass('no-js').addClass('js');

reveal();
scroll();
deQueue();
productListLayout(() => {doResize()});
mobileMenu();

jQuery('.tabs').each(function() {
	tabs(this);
});

jQuery('.product--reviews-widget').each(function() {
	ProductReviewsWidget.attachTo(this);
});

jQuery('*[data-toggle-class]').click(function () {
	const elem = jQuery(this);
	elem.toggleClass(elem.data('toggle-class'));
});

jQuery('.element--accordion-list').each(function () {
	accordionList(this);
});

jQuery('.element--video').each(function () {
	const elem = jQuery(this);
	videoPlayer(this, elem.data('videoUrl'), elem.data('imageUrl'));
});

jQuery('.element--range-slider').each(function () {
	rangeSlider(this);
});

jQuery('.element--image-gallery').each(function () {
	// productGallery(this);
	gallery(this);
});

jQuery('#search-widget').each(function () {
	searchAutocomplete(this);
});

jQuery('.product--favorite-button').each(function () {
	favoriteButton(this);
});

jQuery('*[data-toggle-group]').each(function () {
	toggleGroup(this);
});

jQuery(document).on('click', 'a.loading-trigger, button.loading-trigger, input.loading-trigger', function () {
	showLoader(jQuery(this).closest('.show-loader'));
});

jQuery(document).on('change', 'select.loading-trigger', function () {
	showLoader(jQuery(this).closest('.show-loader'));
});

jQuery(document).on('submit', 'form.loading-trigger', function () {
	showLoader(jQuery(this).closest('.show-loader'));
});

new SimpleLightbox({
	elements: document.querySelectorAll('a.imagezoom')
});

// replaces src of non-loadable images with the url in data-not-found attribute
jQuery('img[data-not-found]').each(function() {
	const imgEl = this;

	if(jQuery(imgEl).complete && imgEl.naturalWidth === 0) {
		// console.log('complete + no-width', imgEl);
		imgEl.src = imgEl.dataset.notFound;
	}

	jQuery(imgEl).on('error', function() {
		// console.log('onError', imgEl);
		imgEl.src = imgEl.dataset.notFound;
	});
});

(function () {
	// If no schema was set via cookie, try to guess if the browser's/system's current color schema
	if(Cookies.get('color-schema') !== 'light' && Cookies.get('color-schema') !== 'dark' && window.matchMedia) {
		try {
			const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
			const colorSchema = isDarkMode ? 'dark' : 'light';
			setColorSchema(colorSchema);
		} catch (e) {
			console.error(e);
		}
	}

	jQuery('#switch-theme-button').click(e => {
		e.stopPropagation();
		const colorSchema = Cookies.get('color-schema') === 'dark' ? 'light' : 'dark';
		setColorSchema(colorSchema);
	});

	function setColorSchema(colorSchema) {
		Cookies.set('color-schema', colorSchema);
		jQuery('link[data-theme-light]').each(function () {
			jQuery(this).attr('href', jQuery(this).data('theme-' + colorSchema));
		});
		jQuery('body').removeClass(`color-scheme-${colorSchema === 'light' ? 'dark' : 'light'}`).addClass(`color-scheme-${colorSchema}`);
	}
})();

jQuery('input.datepicker').each(function() {
	const input = this;
	new Pikaday({
		field: input,
		format: 'DD.MM.YYYY',
		firstDay: 1
	});
});

if(navigator.share) {
	jQuery('[data-share]').each(function() {
		const shareEl = $(this);
		const shareData = shareEl.data('share');

		shareEl.click(async function() {
			await navigator.share(shareData);
		});
	});
}

jQuery(function($) {
	setTimeout(doResize, 250);
	$(window).on('resize', debounce(doResize, 200));
});

jQuery($ => {
	$('.debug-pencil')
		.on('mouseover', e => $(e.currentTarget).parent().addClass('debug-region'))
		.on('mouseout', e => $(e.currentTarget).parent().removeClass('debug-region'));
});

jQuery($ => {
	if(window.navigator.platform.toLowerCase().match(/^win\d+/i)) {
		$('.button--download-for-macos').addClass('button-download-secondary');
	} else if(window.navigator.platform.toLowerCase().match(/^mac/i)) {
		$('.button--download-for-windows').addClass('button-download-secondary');
	}
});

function doResize() {
	let groups = {};
	jQuery('*[data-resize-group]').each(function() {
		const group = $(this).data('resize-group');

		if(!groups.hasOwnProperty(group)) {
			groups[group] = {
				resizeSelectors: $(this).data('resize-selectors'),
				elements: []
			};
		}

		groups[group].elements.push($(this));
	});

	$.each(groups, function() {
		let elements = this.elements;
		$.each(this.resizeSelectors, function () {
			resizeGroup(elements, this);
		});
	});
}

jQuery('ul[data-max-items]').each(function() {
	const list = $(this);
	const items = list.find('li');
	const maxItems = list.data('maxItems') || 10;
	const hiddenItems = items.filter(function() {return !jQuery(this).hasClass('active')}).slice(maxItems);

	const toggle = function() {
		hiddenItems.toggleClass('hidden');
		list.find('.toggle-bar i').toggleClass('fa-caret-down fa-caret-up');
	};

	if(hiddenItems.length < 1) {
		return;
	}

	const toggleElem = $('<li class="toggle-bar"><i class="fa fa-caret-up"></i></li>');
	toggleElem.click(function() {
		toggle();
	});

	list.append(toggleElem);
	toggle();
});

jQuery('[data-href]').each(function() {
	let el = $(this);
	let href = el.data('href');

	el.click(function() {window.location = href});
});



jQuery('[data-search-group]').each(function() {
	const group = $(this);

	const input = group.find('input.search-input');
	const clearBtn = group.find('.search-input-clear');

	const container = group.find('.search-item-container');
	const resultContainer = container.clone().insertAfter(container);
	const elements = resultContainer.find('[data-search-value]');

	const options = {
		shouldSort: true,
		threshold: 0.5,
		location: 0,
		distance: 100,
		maxPatternLength: 32,
		minMatchCharLength: 1,
		includeScore: true,
		keys: ['searchValue']
	};

	resultContainer.empty();

	// prepare elements for Fuse component
	const items = elements.map((idx, el) => {
		el = $(el);
		return {
			element: el,
			searchValue: el.data('searchValue').toLowerCase()
		};
	});
	const fuse = new Fuse(items, options);

	// search with Fuse and only show sorted hits
	const filter = (q) => {
		const results = fuse.search(q);

		const newElements = results.map((result) => {
			return result.item.element;
		});

		container.hide();
		resultContainer.empty().append(newElements);
	};

	const showAll = () => {
		resultContainer.empty().append(elements);
	};

	input.on('input change', debounce(function() {
		if(input.val().length > 0) {
			filter(input.val());
		} else {
			showAll();
		}
	}, 200));

	clearBtn.click(() => input.val(''));
});

/**********************/
/* nicht in Benutzung */
/**********************/

/*
$('.element--radio-btn-bar').each(function () {
	radioButtonBar(this);
});
*/

/*
jQuery('*[data-final-price-calculator]').each(function () {
	finalPriceCalculator(this);
});
*/

/*
jQuery('img[data-not-found]').each(function() {
	const imgEl = this;

	if($(imgEl).complete && imgEl.naturalWidth === 0) {
		// console.log('complete + no-width', imgEl);
		imgEl.src = imgEl.dataset.notFound;
	}

	$(imgEl).on('error', function() {
		// console.log('onError', imgEl);
		imgEl.src = imgEl.dataset.notFound;
	});
});
*/

/*
jQuery('form.modal-form').each(function() {
	const form = $(this);
	const url = form.data('targetUrl');

	form.submit(function(e) {
		e.preventDefault();

		jQuery.ajax({
			url: url,
			type: 'POST',
			dataType: 'html',
			data: form.serialize()
		})
		.done(function (response) {
			let loader = form.closest('.show-loader').find('.element--loader');
			loader.remove();
			showModal(response);
			doResize();
		})
		.fail(function (jqXHR, textStatus) {
			console.log(textStatus);
		});
	});
});
*/

/*
jQuery('.modal-button').each(function() {
	const btn = $(this);
	const url = btn.data('targetUrl');

	btn.click(function(e) {
		e.preventDefault();

		jQuery.ajax({
			url: url,
			type: 'GET',
			dataType: 'html'
		})
		.done(function (response) {
			showModal(response);
			doResize();
		})
		.fail(function (jqXHR, textStatus) {
			console.log(textStatus);
		});
	});
});
*/

/*
// sets scrollTop of element--scroll-list so that the selected element is in the middle if possible
jQuery('.element--scroll-list').each(function() {
	const list = $(this);
	const selected = list.find('.selected');

	const listElHeight = list.height();
	const elHeight = selected.height();
	const elOffset = selected.position().top;


	let offset = elOffset-(listElHeight/2)+(elHeight/2);
	offset = Math.max(0, Math.floor(offset));

	list.scrollTop(offset);
});
*/
